"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#004864",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12C24,5.4,18.6,0,12,0z M2,12C2,6.5,6.5,2,12,2 c2.5,0,4.8,0.9,6.6,2.5l-3.1,3.1l-0.9,0.9l-2.7,2.7L11,12l-2.7,2.7L6,17.1l-1.5,1.5C2.9,16.8,2,14.5,2,12z M12,22 c-2.5,0-4.9-1-6.6-2.5l1.4-1.4l2.6-2.6l2.6-2.6l0.9-0.9l2.8-2.8l0.9-0.9l3.1-3.1C21,7.1,22,9.4,22,12C22,17.5,17.5,22,12,22z"
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,12.8l1.1-1.1c-0.6-0.6-1.3-1.1-2.1-1.5l-1.2,1.2C15.6,11.7,16.4,12.2,17,12.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.4,9.2c-0.1,0-0.3,0-0.4,0c0,0,0,0,0,0c-2.3,0-4.5,0.9-6.1,2.5L7,12.8c1-1,2.4-1.7,3.8-2l0.4-0.4L12.4,9.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.7,8.5c0.5,0.4,1.1,0.8,1.6,1.3l1.1-1.1c-0.5-0.5-1-0.9-1.5-1.3L17.7,8.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.8,5.9C11.6,4.5,6.9,5.4,3.7,8.7l1.1,1.1c2.6-2.6,6.4-3.5,9.7-2.7l0.3-0.3L15.8,5.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5,14.7c1.2-0.2,2.4,0.2,3.3,1.1l1.1-1.1c-0.8-0.8-1.8-1.3-2.9-1.5l-0.4,0.4L11.5,14.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,16c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C13.6,16.7,12.9,16,12,16z"
  })));
};

exports["default"] = _default;